import axios from 'axios'
import $ from 'jquery';
import  {CORS_URL,API_URL} from "../config"


export  function getList(response ='') {
     let tfData = response;
    if( tfData.tournament_fixtures.length === 0) {
        return showError("No Result Found");
    }
    let fixtureData = [];
    for(var ik=0;ik<tfData.tournament_fixtures.length;ik++) {
        fixtureData = tfData.tournament_fixtures[ik];
        let roundOne = [];

        if(typeof fixtureData.tournament_matches[2] !== 'undefined') {
            for (var i = 0; i < fixtureData.tournament_matches[2].length; i++) {
                let mData =  fixtureData.tournament_matches[2][i];
                if(typeof mData.player1_match != 'undefined') {
                    roundOne.push(mData.player1_match);
                } else if(typeof mData.player1) {
                    let byeData = {
                                    "id": 0,
                                    "isBye" : 1,
                                    "player1": mData.player1,
                                    "player2": {
                                        "id": 0,
                                        "name": "BYE",
                                        "user_type": "BYE"
                                    },
                                    "tier": 1,
                                    "match_number": 0,
                                    "player1_description": mData.player1_description,
                                    "player2_description": "BYE"
                                };
                    roundOne.push(byeData);
                }

                if(typeof mData.player2_match != 'undefined') {
                    roundOne.push(mData.player2_match);
                } else if(typeof mData.player2) {
                    let byeData = {
                                    "id": 0,
                                    "isBye" : 1,
                                    "player1": mData.player2,
                                    "player2": {
                                        "id": 0,
                                        "name": "BYE",
                                        "user_type": "BYE"
                                    },
                                    "tier": 1,
                                    "match_number": 0,
                                    "player1_description": mData.player2_description,
                                    "player2_description": "BYE"
                                };
                    roundOne.push(byeData);
                }
            }
            fixtureData.tournament_matches[1] = roundOne;
        }

        tfData.tournament_fixtures[ik] = fixtureData;

    }

    return {
        type : 'fixture',
        payload : {
            tfData : tfData,
            isLoaded : true
        }
    }
}

export function showError(error= "Error!!") {
    return {
        type : 'ErrorFixture',
        payload : {
            fixtureData : error,
            isLoaded : true,
            error : true
        }
    }
}

export function loadData() {
    return {
        type : 'Loading',
        payload : {
            isLoaded : false
        }
    }
}

export function apiRequest() {

    let headers = {
      "Access-Control-Allow-Origin": "*",
      "x-authorization" : localStorage.getItem('authToken')
    }
    return dispatch => {
        /*axios.get('http://13.233.182.217:8080/api/tournament/2/fixtures',{},{headers: headers }).then(response => dispatch(getList(response.data)))
         .catch(error => dispatch(showError()));*/
                //dispatch(getList('sdf'))
        let tournament_id = document.getElementById("tournament_id").value;
        $.ajax({
            url : CORS_URL+API_URL+'/tournament/'+tournament_id+'/fixtures',
            crossDomain: true,
            type: "GET",
            headers: {
                "x-authorization" : "Bearer  eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiIxNSIsInNjb3BlcyI6WyJQTEFZRVIiXSwiaXNzIjoiaHR0cDovL2xvY2FsaG9zdDo4MDgwLyIsImlhdCI6MTU2NDQ5MTAxMiwiZXhwIjo1MjI1NjI4NDQ5MTAxMn0.TkO5W1tQ4PpxvyiTC0h86LmAXm4ffnXgV1uqxF0dP6U52eYxa8Vi0w4i3xDv1lnEMP9lufHR8OxtljiHgLxtwQ",
            },

            success(response) {
                if(response.code === 200) {
                    dispatch(getList(response.data))
                } else {
                    dispatch(showError());
                }
            },
            error() {
                dispatch(showError());
            }
        })
    }
}